import { makeAutoObservable } from "mobx";
import {
  pagingRegimenTestConcepts,
  getRegimenTestConcept,
  createRegimenTestConcept,
  editRegimenTestConcept,
  deleteRegimenTestConcept,
} from "./RegimenTestConceptService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export default class RegimenTestConceptStore {
  regimenTestConceptList = [];
  selectedRegimenTestConcept = null;
  selectedRegimenTestConceptList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  text = "";
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;
  searchObject = {
    keyword: "",
    shortTerm: null,
    requestForm: null,
    month:null,

	  sortForm: null,//sort theo bộ  xét nghiệm
	  sortMonth: null,//sort theo tháng thứ
	  sortTerm: null,//sort theo thời gian
  };

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  updatePageData = (item) => {
    var newSearchObject = {};
    newSearchObject.keyword = this.text;
    newSearchObject.pageIndex = this.page;
    newSearchObject.pageSize = this.rowsPerPage;
    newSearchObject.shortTerm = this.searchObject.shortTerm;
    newSearchObject.requestFormId = this.searchObject.requestForm?.id;
    newSearchObject.month = this.searchObject.month;
	  newSearchObject.sortForm = this.searchObject.sortForm;
	  newSearchObject.sortMonth = this.searchObject.sortMonth;
	  newSearchObject.sortTerm = this.searchObject.sortTerm;
    
    if (item != null) {
      this.page = 1;
      this.text = item.keyword;
      newSearchObject.keyword = this.text;
      this.search(newSearchObject);
    } else {
      newSearchObject.keyword = this.text;
      this.search(newSearchObject);
    }
  };

  search = async (searchObject) => {
    this.loadingInitial = true;
    try {
      let data = await pagingRegimenTestConcepts(searchObject);
      this.regimenTestConceptList = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;

      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleEditRegimenTestConcept = (id) => {
    this.getRegimenTestConcept(id).then(() => {
      this.shouldOpenEditorDialog = true;
    });
  };

  handleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.shouldOpenConfirmationDeleteListDialog = false;
    this.updatePageData();
  };

  handleDelete = (id) => {
    this.getRegimenTestConcept(id).then(() => {
      this.shouldOpenConfirmationDialog = true;
    });
  };

  handleDeleteList = () => {
    this.shouldOpenConfirmationDeleteListDialog = true;
  };

  handleConfirmDelete = () => {
    this.deleteRegimenTestConcept(this.selectedRegimenTestConcept.id);
  };

  handleConfirmDeleteList = async () => {
    let listAlert = [];
    for (var i = 0; i < this.selectedRegimenTestConceptList.length; i++) {
      try {
        await deleteRegimenTestConcept(this.selectedRegimenTestConceptList[i].id);
      } catch (error) {
        listAlert.push(this.selectedRegimenTestConceptList[i].name);
        console.log(error);
        console.log(listAlert.toString());
        toast.warning("toast.delete_fail");
      }
    }
    this.handleClose();
    toast.success("Đã xóa thành công!");
  };
  handleSetSearchObject = (item) => {

    // if (item) {
    if (item.pageIndex) {
      this.page = item.pageIndex;
      //this.rowsPerPage = item.pageSize
    }
    if(item.keyword != "") {
      this.text = item.keyword;
    }
    else{
      this.text = "";
    }
    this.searchObject = item;
    // } else {
    //   this.searchObject = this.initSearchObject;
    // }
  
    // console.log(this.searchObject)
  }

  handleSelectRegimenTestConcept = (regimenTestConcept) => {
    this.selectedRegimenTestConcept = regimenTestConcept;
  };

  handleSelectListRegimenTestConcept = (regimenTestConcepts) => {
    this.selectedRegimenTestConceptList = regimenTestConcepts;
  };

  getRegimenTestConcept = async (id) => {
    if (id != null) {
      try {
        let data = await getRegimenTestConcept(id);
        this.handleSelectRegimenTestConcept(data.data);
      } catch (error) {
        console.log(error);
        toast.warning("toast.get_fail");
      }
    } else {
      this.handleSelectRegimenTestConcept(null);
    }
  };

  createRegimenTestConcept = async (regimenTestConcept) => {
    try {

      await createRegimenTestConcept(regimenTestConcept);
      toast.success("Thêm mới thành công!");
      this.handleClose();

    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi thêm mới!");
    }
  };

  editRegimenTestConcept = async (regimenTestConcept) => {
    try {
      await editRegimenTestConcept(regimenTestConcept);
      toast.success("Cập nhật thành công!");
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.warning("Có lỗi xảy ra khi cập nhật!");
    }
  };

  deleteRegimenTestConcept = async (id) => {
    try {
      const res = await deleteRegimenTestConcept(id);
      if (res?.data) {
        toast.success("Đã xoá bản ghi");
      } else {
        toast.warning("Không thể xoá vì có dữ liệu ràng buộc");
      }
      this.handleClose();
    } catch (error) {
      console.log(error);
      toast.error("Có lỗi xảy ra, vui lòng thử lại sau");
    }
  };
  resetSearchObject = () => {
    this.searchObject = {
      shortTerm: null,
      requestForm: null,
      month: null,
      sortForm: null,//sort theo bộ  xét nghiệm
      sortMonth: null,//sort theo tháng thứ
      sortTerm: null,//sort theo thời gian
    };
    this.text = "";
    this.page = 1;
    this.rowsPerPage = 10;
  }
  handleSetSortField = item => {
    this.page = 1;
    this.searchObject = {
      ...this.searchObject,
      //set các trường sort khác = null
      sortForm: null,//sort theo bộ  xét nghiệm
      sortMonth: null,//sort theo tháng thứ
      sortTerm: null,//sort theo thời gian
      ...item,
    };
    this.updatePageData();
  }
}
